import { useLocalizedOptionsValue } from '../../../../../hooks'
import { EmailInput, EmailType } from '../../../../../utils/classes/graphql'
import { OwnInfoContactWrapper } from './own-info-contact-wrapper'

const newEmail: EmailInput = {
  id: null,
  ensisijainen: false,
  poisto: 0,
  sahkopostiosoite: '',
  tyyppi: EmailType.Email
}

export const Emails = () => {
  const emailTypeOptions = useLocalizedOptionsValue('emailTypeOptions')

  return (
    <OwnInfoContactWrapper
      name="yhteystiedot.sahkopostit"
      keyPostfix="email"
      sectionTranslationId="emailAddresses"
      newContactObject={newEmail}
      contactInfoProps={{
        contactTypePostfix: '.emailType',
        contactValuePostfix: '.sahkopostiosoite',
        contactTypeOptions: emailTypeOptions
      }}
      gridProps={{ md: 8 }}
    />
  )
}
